<template>
    <div class="pc">
        <div class="pc-codeWrap">
            <div class="pc-codeWrap-code">
                <img id="codeImg" class="pc-codeWrap-code-img" :src="codeUrl" alt="">
            </div>
            <div class="pc-codeWrap-into">请扫码以上二维码填报</div>
            <div style="color: red; margin: 18px; font-size: 12px;">建议不要使用IE浏览器，请使用Microsoft Edge浏览器、Chrome浏览器、360浏览器极速模式。</div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return{
            codeUrl: ''
        }
    },
    methods: {
        async onCheckScan() {
            try{
                const data = await this.$api.formsCheckScan({
                    isShowErrorMsg: 'true'
                });
                localStorage.setItem('token', data.token);
                location.href = `${this.$api.suffix}/pc-sign/index.html?id=${data.formsId}`
            }catch(e) {
                if(e.code == 601) {
                    this.onCheckScan();
                }else{
                    const wrapReg = /(.+)\n/;
                    const _msg = document.domain === 'dev.gdsteam.net' ? wrapReg.exec(e.msg)[1] : e.msg;
                    this.$message.error(_msg);
                }
            }
            
        }
    },
    mounted() {
        const _this = this;
        this.codeUrl = '/formsQrcode';
        document.getElementById('codeImg').onload = function() {
            _this.onCheckScan();
        }
    }
}
</script>
<style lang="scss" scoped>
.pc{
    height: 100%;
    background: #ddd;
    background: url('~images/pc_code_bg.jpg') no-repeat;
    background-size: cover;
    padding-top: 198px;
    .pc-codeWrap{
        width: 380px;
        height: 397px;
        background-color: #fff;
        margin: 0 auto;
        text-align: center;
    }
    .pc-codeWrap-code{
        padding-top: 50px;
    }
    .pc-codeWrap-code-img{
        width: 250px;
        height: 250px;
    }
    .pc-codeWrap-into{
        margin-top: 29px;
        font-size: 18px;
        color: #666;
    }
}
</style>